/**
 * @module project/components/participate_form/info_step
 */
import React, { PropTypes, Component } from 'react';
import InfoStepImage from 'project/components/participate_form/info_step_image';
import InfoStepName from 'project/components/participate_form/info_step_name';

/**
 * Participate upload form step that shows entry details form and adds a new
 * entry on submit.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const ParticipateInfoStep = (props) => {
  const { entryType } = props
  const Component = entryType == 'image'? InfoStepImage:InfoStepName
  return <Component {...props}/>
}

/**
 * PropTypes.
 *
 * @property {string} entryType - entry type for this project
 * @property {object} project - project data object
 * @property {shape} entry - entry data object
 * @property {shape} revision - revision data object
 * @property {string} error - submission error
 * @property {bool} isRevision - controls if entry is a revision of previous entry
 * @property {func} onSubmitParticipateForm - function called when form is submitted
 * @property {func} onChangeEntry - function called when change entry button is clicked
 * @property {func} onChangeImage - function called when entry image should be changed
 * @property {func} onCloseForm - function called when close form button is clicked
 */
ParticipateInfoStep.propTypes = {
  entryType: PropTypes.string,
  project: PropTypes.object,
  entry: PropTypes.shape({
    licensing: PropTypes.object,
    description: PropTypes.string,
    name: PropTypes.string,
    file: PropTypes.string,
  }),
  revision: PropTypes.shape({
    thumbnail: PropTypes.string,
  }),
  error: PropTypes.string,
  isRevision: PropTypes.bool,
  onSubmitParticipateForm: PropTypes.func,
  onChangeEntry: PropTypes.func,
  onChangeImage: PropTypes.func,
  onCloseForm: PropTypes.func,
};

export default ParticipateInfoStep;



// WEBPACK FOOTER //
// ./project/components/participate_form/info_step.jsx